import React from 'react';
import Paper from '@material-ui/core/Paper';
import { t } from 'ttag';
import DataTable from '../../../components/DataTable';
import { BASE_STATUS_TITLES, USER_TYPES_LABEL } from '../../../utils/enums';
import useApi from '../../../api';
import useDataList from '../../../hooks/useDataList';

const ListView = () => {
  const api = useApi();
  const { data, loading, onEdit } = useDataList({
    schema: api.schema.users,
    router: api.router.permissions,
  });

  const columns = [
    { title: t`Id`, field: 'id', editable: 'never' },
    { title: t`Повне Імя`, field: 'fullName' },
    {
      title: t`Тип користувача`,
      field: 'types',
      render: ({ types }) => types.map((type) => `${USER_TYPES_LABEL[type]} `),
    },
    {
      title: t`Статус`,
      field: 'status',
      render: ({ status }) => BASE_STATUS_TITLES[status],
    },
  ];

  return (
    <Paper>
      <DataTable
        isLoading={loading}
        title={t`Доступи користувачів`}
        columns={columns}
        data={data || []}
        onEdit={onEdit}
      />
    </Paper>
  );
};

export default ListView;
